import { render, staticRenderFns } from "./DeleteAccountPasswordPromptModal.vue?vue&type=template&id=6e580bf9&scoped=true&"
import script from "./DeleteAccountPasswordPromptModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountPasswordPromptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e580bf9",
  null
  
)

export default component.exports